module.exports = __webpack_public_path__ + "img/logo-trx.a14dc44.svg";